// extracted by mini-css-extract-plugin
export default {"productDetailHeader":"ProfileListCard_productDetailHeader__yBgn3","icons":"ProfileListCard_icons__KRI3C","logOutIcon":"ProfileListCard_logOutIcon__OIsEo"};